export class ObjectUtil {
  public static parse(jsonString: string, fallback = {}) {
    try {
      return JSON.parse(jsonString);
    } catch (err) {
      return fallback;
    }
  }
}
